import script from "./DashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardView.vue?vue&type=script&setup=true&lang=js"

import "./DashboardView.vue?vue&type=style&index=0&id=74b76885&lang=css"

const __exports__ = script;

export default __exports__